import { URLS } from '@/config/urls';
import { Translate } from 'next-translate';
import { UserReward, UserRewardsLevel } from '../rewards.types';
import { TileFromReward } from './tiles-overview.types';
import { ClubRepresentation, ClubWithRaffles } from '@/utils/api/teams/schemas';
import rewards from '@/pages/rewards';

export const formatTilesFromRewards = (clubs: ClubWithRaffles[]): TileFromReward[] =>
  clubs.map(clubs => ({
    label: clubs.name,
    title: clubs.name,
    endAt: undefined,
    millisecondsUntilEnd: undefined,
    image: { src: clubs.banner || '', alt: clubs.name },
    href: 'rewards/' + clubs.pk,
    raffles: clubs.raffles,
  })) || [];
